module.exports = __webpack_public_path__ + "img/collection-weddingRingstrisets.f305239.webp";